import {ColorService} from './color.service';

//#########################################################################
//
// This service is used to keep track of all information about the turtle
// so we keep track of the following thing and provide an interface to access
// those information from a component:
//      - position x
//      - position y
//      - orientation
//      - pen up or down
//      - screen color
//      - pen color
//      - pen width
//
//#########################################################################

export class TurtleService {

  private posX: number;
  private posY: number;
  public startX: number;
  public startY: number;
  private direction: number;
  private isVisibile: boolean;
  private penIsDown: boolean;
  private isErasing: boolean;
  private penColor: ColorService;
  private previousPenColor: ColorService;
  private penWidth: number;
  private wasErasingWhite: boolean;
  private readonly DEFAULT_PENWIDTH = 1;

  constructor() {
    this.posX = 0;
    this.posY = 0;
    this.direction = 0;
    this.isVisibile = true;
    this.penIsDown = true;
    this.isErasing = false;
    this.wasErasingWhite = false;
    this.penColor = new ColorService("black");
    this.previousPenColor = new ColorService("black");
    this.penWidth = this.DEFAULT_PENWIDTH;
  }

  getX(): number {
    return this.posX;
  }

  getY(): number {
    return this.posY;
  }

  setX(x: number): void {
    this.posX = x;
  }

  setY(y: number): void {
    this.posY = y;
  }

  getDirection(): number {
    return this.direction;
  }

  setDirection(d: number): void {
    this.direction = d;
  }

  getPenDown(): boolean {
    return this.penIsDown;
  }

  setPenVisible(isVisible: boolean): void {
    if (isVisible) {
      this.penIsDown = true;
    } else {
      this.penIsDown = false;
    }

  }

  setTurtleVisible(isVisible: boolean): void {
    if (isVisible){
      this.isVisibile = true;    
    } else {
      this.isVisibile = false;
    }

  }

  getVisibility(): boolean {
    return this.isVisibile;
  }

  reset(x: number, y: number, completeReset: boolean): void {
    this.isVisibile = true;
    this.penIsDown = true;
    this.posX = x;
    this.posY = y;
    this.direction = 0;
    this.penWidth = this.DEFAULT_PENWIDTH;

    if (completeReset) {
      this.penColor = new ColorService("black");
      this.previousPenColor = new ColorService("black");
    }
  }

  setPenColor(c: ColorService): void {
    this.penColor = c;
  }

  getPenColor(): ColorService {
    return this.penColor;
  }

  //solved by setting pencolor same to background color.
  //this is not the perfect solution since the user might 
  //change the background color afterwards and might see
  //pe and ppt will eventually become depracated...
  setErasing(b: boolean, screenColor): void {
    this.isErasing = b;
    if(b){
      this.previousPenColor = this.penColor;
      this.penColor = screenColor;
    }else{
      this.penColor = this.previousPenColor;
      this.previousPenColor = screenColor;
    }
  }

  getErasing(): boolean {
    return this.isErasing;
  }

  getPenWidth(): number {
    return this.penWidth;
  }

  setPenWidth(penWidth: number): void {
    this.penWidth = penWidth;
  }

  setWasErasingWhite(b: boolean):void{
    this.wasErasingWhite = b;
  }

  getWasErasingWhite(): boolean{
    return this.wasErasingWhite;
  }
}
// vim: shiftwidth=2



// WEBPACK FOOTER //
// ./src/app/services/turtle.service.ts